/**
 * Trim-aware non-empty string check. Returns `true` when `value` is a
 * string with at least one non-whitespace character. Useful as a guard
 * for optional API fields where `null`, `undefined`, and the empty
 * string all mean "missing".
 */
export function nonEmpty(value: string | null | undefined): boolean {
	return value != null && value.trim().length > 0;
}
